import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ModalWrapperComponent } from '@myapp/features/widgets/components';
import { SharedUICheckboxComponent } from '../../../../../modules/forms/components/shared-ui-checkbox/shared-ui-checkbox.component';
import { SharedUiTextInputComponent } from '../../../../../modules/forms/components/shared-ui-text-input/shared-ui-text-input.component';
import { SharedUiTextareaComponent } from '../../../../../modules/forms/components/shared-ui-textarea/shared-ui-textarea.component';
import { BaseEditorComponent } from '../../base-editor/base-editor.component';
import { ModuleForm } from './module.form';

@Component({
  selector: 'app-modules-editor',
  templateUrl: './modules-editor.component.html',
  styleUrls: ['./modules-editor.component.scss'],
  standalone: true,
  imports: [ModalWrapperComponent, FormsModule, SharedUiTextInputComponent, SharedUiTextareaComponent, SharedUICheckboxComponent]
})
export class ModulesEditorComponent extends BaseEditorComponent {
  @Input() form?: ModuleForm;

  ngOnInit() {
    super.ngOnInit();
  }
}
